import { DEFAULT_ROLES } from '../permissions';

export enum SUPPORT_TICKET_PRIORITY {
  LOW = 'LOW', //'Low',
  MEDIUM = 'MEDIUM', //'Medium',
  HIGH = 'HIGH', //'High',
  CRITICAL = 'CRITICAL', //'High',
  NOT_DEFINED = 'NOT_DEFINED',
}

export const SUPPORT_TICKET_REFERENCE_SECTION = {
  SUPPORT_TICKETS: 'Tickets',
};

export enum SUPPORT_TICKET_REFERENCE_CATAGORIES {
  CATEGORIES = 'Categories',
  SUB_CATEGORIES = 'Sub_Categories',
  CATEGORY = 'Category',
  SUB_CATEGORY = 'Sub Category',
}

export const SUPPORT_TICKETS_EMPLOYEE_SPEED_DIAL = {
  CREATE_THREAD: 'CREATE_THREAD',
};

export const SUPPORT_TICKET_BILL_STATE = {
  BILLABLE: 'BILLABLE',
  PENDING: 'PENDING',
  BILLED: 'BILLED',
};

export const EMPLOYEE_TICKETS_ROLES = [
  DEFAULT_ROLES.EMPLOYEE,
  DEFAULT_ROLES.PEOPLE_PARTNER,
  DEFAULT_ROLES.PROJECT_MANAGER,
  DEFAULT_ROLES.MANAGER,
];

export enum TICKET_TYPE_ENUM {
  INTERNAL = 'INTERNAL',
  CUSTOMER = 'CUSTOMER',
}
